<app-rfi-answer-completeness [completeness]="completeness()" />
<app-rfi-metric-grid [cards]="cards()" />
@if (chartData(); as chartData) {
  <div class="flex flex-col gap-2">
    <h4 class="font-semibold">
      {{ 'project.steps.providerResults.individual.financeChartTitle' | transloco }}
    </h4>
    <div class="h-64">
      <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="100%" />
    </div>
  </div>
}
